import { take, put, call, takeEvery } from 'redux-saga/effects'
import { makeSaga } from './util'

import { types as guideTypes, actions as guideActions } from '../reducers/guides'

import { getEffect } from './network'

import { getGuideJsonUrl } from '../config'

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

export function * getGuideJsonEffect ({ guideId }) {
  const request = {
    url: getGuideJsonUrl(guideId),
    authenticated: false,
    options: { noHeaders: true }
  }
  const chan = yield call(getEffect, request)
  return yield take(chan)
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

export function * getGuideJsonFlow ({ payload }) {
  const guideObject = yield call(getGuideJsonEffect, payload)
  if (guideObject.error) {
    yield put(guideActions.errorRequest())
    return
  }
  yield put(guideActions.finishRequest(guideObject))
  yield put(guideActions.successRequest())
}

export default makeSaga([
  takeEvery(guideTypes.GUIDE_JSON_REQUEST, getGuideJsonFlow)
])
